import { render, staticRenderFns } from "./AddEditModal.vue?vue&type=template&id=0ab6c068&scoped=true"
import script from "./AddEditModal.vue?vue&type=script&lang=js"
export * from "./AddEditModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditModal.vue?vue&type=style&index=0&id=0ab6c068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab6c068",
  null
  
)

export default component.exports